import React, { useState } from 'react';
import { ChevronDown, ChevronUp, ArrowRight } from 'lucide-react';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border-b border-gray-200">
      <button
        className="w-full py-6 flex justify-between items-center text-left"
        onClick={onClick}
      >
        <h3 className="text-lg font-semibold text-[#113262] pr-8">{question}</h3>
        <ChevronDown
          className={`w-5 h-5 text-[#F49611] transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''
            }`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-6' : 'max-h-0'
          }`}
      >
        <p className="text-gray-600">{answer}</p>
      </div>
    </div>
  );
};

const PMSFaqs = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "What is Portfolio Management Service (PMS)?",
      answer: "PMS is a professional investment service where experienced portfolio managers handle your investment portfolio with a personalized approach. At Maxiom Wealth, we offer various PMS options like Jewel PMS (Top 350 companies), Spark PMS (351-1000 ranked companies), and GEM (momentum and quality focus)."
    },
    {
      question: "What is the minimum investment amount for PMS?",
      answer: "As per SEBI regulations, the minimum investment amount for PMS is Rs. 50 lakhs. This allows us to create a well-diversified portfolio that aligns with your investment objectives and risk profile."
    },
    {
      question: "How is PMS different from Mutual Funds?",
      answer: "Unlike mutual funds where investments are pooled, PMS offers personalized portfolio management with direct ownership of securities. You get transparency in holdings, customization options, and tax-efficient investing strategies tailored to your needs."
    },
    {
      question: "What is the investment approach in Maxiom's PMS?",
      answer: "We follow a scientific and process-driven approach using our proprietary LSG (Liquidity Safety Growth) Framework and Three Eye Fund Selection Framework. Our investment philosophy focuses on creating sustainable wealth through disciplined investing."
    },
    {
      question: "How can I track my PMS investments?",
      answer: "You get access to our advanced portfolio tracking system with detailed reports, real-time updates, and performance analytics. Our dedicated relationship managers also provide regular portfolio reviews and updates."
    }
  ];

  return (
    <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
      <div className="flex flex-col md:flex-row gap-16">
        <div className="md:w-1/3">
          <div className="sticky top-8">
            <div className="w-12 h-0.5 bg-[#F49611] mb-3"></div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">
              Common Questions About PMS
            </h2>
            <p className="text-gray-600 mb-8">
              Get answers to frequently asked questions about our PMS offerings.
              For more detailed discussions, our investment experts are ready to help.
            </p>
            <a href="/meeting" className="flex items-center text-[#F49611] font-semibold hover:gap-2 transition-all">
              <span>Speak With An Expert</span>
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
          </div>
        </div>
        <div className="md:w-2/3">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={index === openIndex}
              onClick={() => setOpenIndex(index === openIndex ? -1 : index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PMSFaqs;